export const movies = [
  {
    id: 1,
    title: "流浪地球3",
    category: "dianying",
    rating: 8.9,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20futuristic%20space%20station%20and%20earth%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20film%20poster%20style%2C%20dark%20tones%20with%20warm%20orange%20highlights%2C%20professional%20movie%20artwork&width=400&height=560&seq=movie-01&orientation=portrait",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，一群勇敢的年轻人挺身而出，为人类的未来展开生死之战。本片延续前作的宏大叙事，在视觉特效和情感深度上更进一步。",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健", "沙溢"],
    tags: ["科幻", "冒险", "灾难"],
    updateTime: "2026-08-09",
    duration: "148分钟",
    summary: "人类命运共同体的终极抉择，视觉奇观与情感共鸣的完美融合。"
  },
  {
    id: 2,
    title: "满江红2",
    category: "dianying",
    rating: 8.5,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20with%20ancient%20palace%20courtyard%20and%20red%20lanterns%2C%20suspenseful%20atmosphere%2C%20cinematic%20film%20poster%20style%2C%20dark%20red%20and%20gold%20tones%2C%20professional%20movie%20artwork&width=400&height=560&seq=movie-02&orientation=portrait",
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇的密室杀人案，将一群各怀心思的小人物卷入了一场惊天阴谋。本片延续前作的悬疑风格，格局更大，反转更多。",
    director: "张艺谋",
    actors: ["沈腾", "易烊千玺", "张译", "雷佳音"],
    tags: ["悬疑", "历史", "剧情"],
    updateTime: "2026-08-08",
    duration: "159分钟",
    summary: "一场围绕忠义与背叛的惊心博弈，小人物也有大情怀。"
  },
  {
    id: 3,
    title: "哪吒之魔童闹海2",
    category: "dongman",
    rating: 9.1,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20mythological%20warrior%20boy%20with%20flaming%20wheels%20and%20red%20ribbon%2C%20epic%20fantasy%20style%2C%20vibrant%20red%20and%20gold%20colors%2C%20cinematic%20animation%20film%20artwork&width=400&height=560&seq=movie-03&orientation=portrait",
    description: "天劫之后，哪吒和敖丙的灵魂虽被保住，但肉身即将魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，然而一场更大的危机正在降临。继前作50亿票房奇迹后，再度引爆国漫热潮。",
    director: "饺子",
    actors: ["吕艳婷", "囧森瑟夫", "瀚墨", "陈浩"],
    tags: ["动画", "奇幻", "冒险"],
    updateTime: "2026-08-10",
    duration: "144分钟",
    summary: "我命由我不由天，国漫之光再度归来。"
  },
  {
    id: 4,
    title: "庆余年第二季",
    category: "dianshiju",
    rating: 8.7,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20with%20ancient%20scholar%20in%20traditional%20robes%2C%20palace%20intrigue%20theme%2C%20cinematic%20TV%20series%20poster%20style%2C%20warm%20golden%20and%20dark%20tones%2C%20professional%20artwork&width=400&height=560&seq=movie-04&orientation=portrait",
    description: "范闲在经历了生死考验后，继续在庆国朝堂中周旋。面对错综复杂的权力斗争，他一步步揭开身世之谜，同时守护心中所爱。第二季剧情更加紧凑，人物关系更加复杂。",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明", "吴刚"],
    tags: ["古装", "权谋", "剧情"],
    updateTime: "2026-08-07",
    duration: "36集",
    summary: "朝堂风云再起，范闲的传奇继续书写。"
  },
  {
    id: 5,
    title: "封神第二部",
    category: "dianying",
    rating: 8.3,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20grand%20battle%20scene%2C%20cinematic%20fantasy%20film%20artwork%2C%20golden%20and%20crimson%20tones&width=400&height=560&seq=movie-05&orientation=portrait",
    description: "姬发回到西岐后，殷商大军压境。在姜子牙和众神的帮助下，西岐军民奋起抵抗，一场决定天下命运的大战即将展开。宏大战场、震撼特效，续写中国神话史诗。",
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适", "陈牧驰"],
    tags: ["奇幻", "战争", "神话"],
    updateTime: "2026-08-06",
    duration: "152分钟",
    summary: "中国神话史诗的壮丽终章，封神宇宙全面开启。"
  },
  {
    id: 6,
    title: "狂飙",
    category: "dianshiju",
    rating: 9.2,
    year: 2023,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20TV%20drama%20poster%20with%20two%20men%20in%20tense%20confrontation%2C%20modern%20urban%20setting%2C%20cinematic%20series%20poster%20style%2C%20dark%20moody%20tones%2C%20professional%20artwork&width=400&height=560&seq=movie-06&orientation=portrait",
    description: "一部横跨二十年的扫黑除恶群像剧。从一名普通刑警的视角，讲述了与黑恶势力长达二十年的殊死搏斗。展现了扫黑除恶工作中的惊心动魄和人性的复杂面。",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐", "张志坚"],
    tags: ["犯罪", "剧情", "悬疑"],
    updateTime: "2026-08-05",
    duration: "39集",
    summary: "扫黑除恶二十年，正义与邪恶的终极较量。"
  },
  {
    id: 7,
    title: "奔跑吧第八季",
    category: "zongyi",
    rating: 7.8,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20and%20laughing%2C%20colorful%20and%20energetic%20style%2C%20TV%20show%20poster%20artwork%2C%20bright%20vibrant%20colors%2C%20professional%20design&width=400&height=560&seq=movie-07&orientation=portrait",
    description: "全新一季奔跑吧火热回归！固定嘉宾阵容升级，更有重量级飞行嘉宾加盟。从城市街头到山川湖海，每一期都是全新的冒险和欢笑。最具国民度的户外竞技真人秀。",
    director: "姚译添",
    actors: ["李晨", "郑恺", "杨颖", "白鹿"],
    tags: ["真人秀", "竞技", "搞笑"],
    updateTime: "2026-08-10",
    duration: "12期",
    summary: "跑男团再出发，用欢笑和汗水点燃这个夏天。"
  },
  {
    id: 8,
    title: "熊出没·重启未来",
    category: "dongman",
    rating: 8.1,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20movie%20poster%20with%20two%20bears%20and%20a%20woodcutter%20in%20futuristic%20setting%2C%20colorful%20and%20fun%20style%2C%20animation%20film%20artwork%2C%20bright%20and%20warm%20tones&width=400&height=560&seq=movie-08&orientation=portrait",
    description: "熊大、熊二和光头强意外穿越到未来世界，面对高度发达的科技和环境危机，他们必须联手拯救未来。影片融入环保主题，寓教于乐，适合全家人一起观看。",
    director: "林汇达",
    actors: ["张伟", "张秉君", "谭笑"],
    tags: ["动画", "喜剧", "家庭"],
    updateTime: "2026-08-04",
    duration: "98分钟",
    summary: "熊大熊二光头强穿越未来，爆笑冒险再出发。"
  },
  {
    id: 9,
    title: "大江大河3",
    category: "dianshiju",
    rating: 8.6,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20set%20in%201990s%20China%20with%20businessmen%20in%20suits%2C%20reform%20and%20opening%20up%20era%2C%20cinematic%20TV%20series%20artwork%2C%20nostalgic%20warm%20tones&width=400&height=560&seq=movie-09&orientation=portrait",
    description: "时间来到九十年代，宋运辉、雷东宝、杨巡三人在改革开放的浪潮中各自前进。面对新的机遇和挑战，他们的命运再次交织。展现了中国经济腾飞时代的众生相。",
    director: "孔笙",
    actors: ["王凯", "杨烁", "董子健", "杨采钰"],
    tags: ["年代", "剧情", "励志"],
    updateTime: "2026-08-03",
    duration: "40集",
    summary: "改革开放浪潮中的奋斗者群像，时代洪流下的人生命运。"
  },
  {
    id: 10,
    title: "向往的生活第八季",
    category: "zongyi",
    rating: 8.0,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20slow-paced%20variety%20show%20poster%20with%20countryside%20farmhouse%20and%20celebrities%20cooking%2C%20peaceful%20rural%20setting%2C%20warm%20pastoral%20style%2C%20TV%20show%20artwork&width=400&height=560&seq=movie-10&orientation=portrait",
    description: "回到田园，回归生活。黄磊和何炅带领新老朋友们在蘑菇屋中过着自给自足的生活。一日三餐，三五好友，把酒话桑麻。在这个快节奏的时代，找到生活的另一种可能。",
    director: "王征宇",
    actors: ["黄磊", "何炅", "张艺兴", "彭昱畅"],
    tags: ["真人秀", "生活", "美食"],
    updateTime: "2026-08-09",
    duration: "14期",
    summary: "在田园中寻找生活的本真，用美食和友情治愈心灵。"
  },
  {
    id: 11,
    title: "志愿军第三部",
    category: "dianying",
    rating: 8.4,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20war%20film%20poster%20with%20soldiers%20in%20battle%2C%20epic%20historical%20war%20scene%2C%20cinematic%20film%20artwork%2C%20dramatic%20lighting%20with%20smoke%20and%20fire%2C%20professional%20movie%20poster&width=400&height=560&seq=movie-11&orientation=portrait",
    description: "抗美援朝战争进入最后的关键阶段。志愿军将士们在极端艰苦的条件下，以钢铁般的意志和巨大的牺牲，最终赢得了战争的胜利。史诗般的战争场面和感人至深的英雄故事。",
    director: "陈凯歌",
    actors: ["唐国强", "刘劲", "王伍福", "张涵予"],
    tags: ["战争", "历史", "剧情"],
    updateTime: "2026-08-02",
    duration: "165分钟",
    summary: "用血肉之躯筑起和平长城，致敬最可爱的人。"
  },
  {
    id: 12,
    title: "一念永恒第三季",
    category: "dongman",
    rating: 8.8,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20donghua%20animation%20poster%20with%20young%20cultivator%20in%20white%20robes%20using%20magic%2C%20fantasy%20cultivation%20world%2C%20anime%20style%20artwork%2C%20ethereal%20blue%20and%20white%20tones&width=400&height=560&seq=movie-12&orientation=portrait",
    description: "白小纯终于踏入天人境界，然而更大的挑战接踵而至。面对蛮荒入侵和宗门危机，他必须做出艰难的抉择。国漫顶级仙侠之作，画面精美，剧情紧凑。",
    director: "苏晓光",
    actors: ["苏尚卿", "李诗萌", "赵爽"],
    tags: ["动画", "仙侠", "冒险"],
    updateTime: "2026-08-08",
    duration: "52集",
    summary: "白小纯的修仙之路再升级，国漫仙侠巅峰之作。"
  },
  {
    id: 13,
    title: "孤注一掷2",
    category: "dianying",
    rating: 8.2,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20digital%20screen%20and%20warning%20signs%2C%20cybercrime%20theme%2C%20cinematic%20film%20artwork%2C%20dark%20red%20and%20black%20tones%2C%20professional%20style&width=400&height=560&seq=movie-13&orientation=portrait",
    description: "网络安全专家卷入了一起跨国网络诈骗大案。在虚拟与现实交织的战场上，他与犯罪分子展开了一场惊心动魄的博弈。影片深刻揭示了网络诈骗的黑暗产业链。",
    director: "申奥",
    actors: ["张艺兴", "金晨", "王传君", "咏梅"],
    tags: ["犯罪", "悬疑", "剧情"],
    updateTime: "2026-08-01",
    duration: "135分钟",
    summary: "网络诈骗背后的惊心真相，一次关乎生命的孤注一掷。"
  },
  {
    id: 14,
    title: "乘风破浪的姐姐第五季",
    category: "zongyi",
    rating: 7.5,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20music%20variety%20show%20poster%20with%20group%20of%20female%20celebrities%20on%20stage%2C%20glamorous%20and%20empowering%20style%2C%20TV%20show%20artwork%2C%20golden%20and%20sparkling%20tones&width=400&height=560&seq=movie-14&orientation=portrait",
    description: "全新一季浪姐再度起航！30位30+姐姐齐聚舞台，用实力打破年龄的偏见。她们用汗水和才华证明：每个年纪都是最好的年纪。舞台效果升级，竞技更加激烈。",
    director: "晏吉",
    actors: ["宁静", "那英", "王心凌", "郑秀妍"],
    tags: ["音乐", "竞技", "真人秀"],
    updateTime: "2026-08-10",
    duration: "12期",
    summary: "三十而骊，乘风破浪，姐姐们用实力定义无限可能。"
  },
  {
    id: 15,
    title: "完美世界",
    category: "dongman",
    rating: 8.6,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%203D%20donghua%20poster%20with%20young%20warrior%20in%20ancient%20fantasy%20world%2C%20epic%20cultivation%20scene%2C%20animation%20artwork%2C%20dark%20golden%20and%20emerald%20tones&width=400&height=560&seq=movie-15&orientation=portrait",
    description: "石昊历经重重磨难，一步步走向至尊之路。从下界八域到九天十地，他独自前行，横扫一切敌。本季制作全面升级，战斗场景更加震撼，世界观更加宏大。",
    director: "汪成果",
    actors: ["锦鲤", "刘晴", "赵双"],
    tags: ["动画", "玄幻", "战斗"],
    updateTime: "2026-08-09",
    duration: "78集",
    summary: "一粒尘可填海，一根草斩尽日月星辰，少年至尊的崛起之路。"
  },
  {
    id: 16,
    title: "长安十二时辰2",
    category: "dianshiju",
    rating: 8.9,
    year: 2026,
    region: "中国大陆",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20thriller%20TV%20drama%20poster%20set%20in%20ancient%20Tang%20dynasty%20city%2C%20suspense%20and%20intrigue%2C%20cinematic%20series%20artwork%2C%20dark%20and%20mysterious%20tones&width=400&height=560&seq=movie-16&orientation=portrait",
    description: "天宝三年，上元节前夕，长安城中暗流涌动。死囚张小敬临危受命，必须在十二个时辰内破解一个足以毁灭整座长安城的惊天阴谋。续作延续前作的高品质制作，剧情更加扣人心弦。",
    director: "曹盾",
    actors: ["雷佳音", "易烊千玺", "周一围", "热依扎"],
    tags: ["古装", "悬疑", "动作"],
    updateTime: "2026-08-05",
    duration: "40集",
    summary: "十二时辰倒计时，一人的生死与一城的存亡。"
  }
];

export const latestMovies = [1, 3, 7, 10, 15, 2, 4, 6];

export const featuredMovies = [3, 1, 6, 5, 12, 2, 4, 9];